<template>
    <div>
        <div class="full" ref="realMap"></div>
        <button @click="showPicker = true">{{btnText}}</button>
        <div class="btootm" v-show="showPicker">
            <mt-picker :slots="slots" :showToolbar="true" valueKey="name" @change="onValuesChange">
                <span class="pickerBtn"></span>
                <span class="pickerBtn right" @click="showPicker = false">关闭</span>
            </mt-picker>
        </div>
        <div class="shade" v-show="showEchats" @click.self="showEchats=false">
            <div>
                <p>{{echatsAddress}}{{btnText}}时序图</p>
                <div ref="echarts"></div>
            </div>
        </div>
    </div>
</template>

<script>
//高德异步加载器
import AMapLoader from "@amap/amap-jsapi-loader";
//echarts
import echarts from "echarts";

export default {
    data() {
        return {
            AMap: null,
            map: null, //高德地图
            markers: [], //地图标注
            showPicker: false, //是否显示要素选择
            elementIndex: 0, //选中的要素类型序号
            realElementIndex: 0, //选中的要素序号
            elementList: [
                {
                    name: "气温",
                    include: [
                        {name:"实时气温",element:'Temp'},
                        {name:"实时最高温",element:'MaxTemp'},
                        {name:"实时最低温",element:'MinTemp'},
                        {name:"今日最高温",element:'TMaxTemp'},
                        {name:"今日最低温",element:'TMinTemp'},
                    ]
                },
                {
                    name: "降水",
                    include: [
                        {name:"近1小时降水",element:'Rain1'},
                        {name:"近3小时降水",element:'Rain3'},
                        {name:"近6小时降水",element:'Rain6'},
                        {name:"近12小时降水",element:'Rain12'},
                        {name:"近24小时降水",element:'Rain24'},
                    ]
                },
                { name: "风力", include: [{name:"平均风",element:'WindV'}, {name:"极大风",element:'MaxWindV'},] },
                { name: "湿度", include: [{name:"实时湿度",element:'RelHum'},] },
                { name: "气压", include: [{name:"实时气压",element:'Press'},] },
                { name: "能见度", include: [{name:"实时能见度",element:'Visib'},] }
            ],
            showEchats: false, //echarts 显示隐藏属性
            echatsAddress: "" //echarts 数据所属地区名称
        };
    },
    mounted() {
        AMapLoader.load({
            key: this.amapKey, // 申请好的Web端开发者Key，首次调用 load 时必填
            version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
            plugins: ["AMap.Geolocation"] //插件列表
        }).then(AMap => {
            this.AMap = AMap;
            this.map = new AMap.Map(this.$refs.realMap, {
                center: [86.738915, 41.765652],
                zoom: 8
            });

            const geolocation = new AMap.Geolocation({
                timeout: 10000,
                // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
                buttonOffset: new AMap.Pixel(10, 20),
                //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                zoomToAccuracy: true,
                //  定位按钮的排放位置,  RB表示右下
                buttonPosition: "RB",
                needAddress: true
            });

            geolocation.getCurrentPosition((status, result) => {
                if (status == "complete") {
                    this.map.setCenter(result.position, true);
                } else {
                    alert("定位失败");
                }
            });

            this.showData(this.elementList[this.elementIndex].include[
                this.realElementIndex
            ].element); //显示数据marker
        }).catch(e => {
            console.log(e);
        });
    },
    computed: {
        slots() {
            const slots = [];
            slots.push({
                flex: 1,
                values: this.elementList.map(item => item.name),
                textAlign: "center"
            });
            slots.push({
                divider: true,
                content: "-"
            });
            slots.push({
                flex: 1,
                values: this.elementList[0].include,
                textAlign: "center"
            });
            return slots;
        },
        btnText() {
            return this.elementList[this.elementIndex].include[
                this.realElementIndex
            ].name;
        }
    },
    methods: {
        onValuesChange(picker, values) {
            const elementIndex = this.elementList.findIndex(
                item => item.name == values[0]
            );
            if (elementIndex != this.elementIndex) {
                this.elementIndex = elementIndex;
                picker.setSlotValues(1, this.elementList[elementIndex].include);
            } else {
                this.realElementIndex = this.elementList[
                    elementIndex
                ].include.findIndex(item => item.element == values[1].element);
                this.showData(values[1].element); //显示数据marker
            }
        },

        showData(element) {
            //删除地图标记
            this.markers.forEach(marker => this.map.remove(marker));
            this.markers = [];

            const AMap = this.AMap;
            if (!AMap) return;

            this.ajax('wxInterface/realTimeQuery',{element},dataList => {
                if(typeof dataList === 'string'){
                    return;
                }
                dataList.forEach(data => {
                    const lnglat = [data.lng, data.lat];
                    let color = "#00b2d5";
                    const marker = new AMap.CircleMarker({
                        center: lnglat,
                        radius: 6,
                        strokeColor: "#ffffff",
                        fillColor: color,
                        extData: data
                    });
                    marker.on("touchend", this.markerClick);
                    const nameMarker = new AMap.Text({
                        position: lnglat,
                        text: data.name,
                        offset: [0, 4],
                        anchor: "top-center",
                        style: {
                            "background-color": "transparent",
                            color: color,
                            border: "none",
                            "font-size": "small"
                        }
                    });
                    const valMarker = new AMap.Text({
                        position: lnglat,
                        text: data.val,
                        offset: [0, -4],
                        anchor: "bottom-center",
                        style: {
                            "background-color": "transparent",
                            color: color,
                            border: "none",
                            "font-size": "small"
                        }
                    });
                    this.map.add(nameMarker);
                    this.map.add(valMarker);
                    this.map.add(marker);
                    this.markers.push(marker);
                    this.markers.push(nameMarker);
                    this.markers.push(valMarker);
                });
            });
        },
        //marker点击事件
        markerClick(e) {
            const data = e.target.getExtData();
            this.echatsAddress = data.name;
            this.showEchats = true;
            setTimeout(() => {
                const times = data.weather24.map(item => item.time);
                const values = data.weather24.map(item => item.val);
                const echart = echarts.init(this.$refs.echarts);
                echart.setOption({
                    tooltip: {
                        show: true,
                        formatter: "{b}时" + this.btnText + ":{c}"
                    },
                    xAxis: {
                        type: "category",
                        data: times
                    },
                    yAxis: {
                        type: "value"
                    },
                    series: [
                        {
                            data: values,
                            type: "line"
                        }
                    ]
                });
            }, 100);
        }
    }
};
</script>

<style lang="less" scoped>
.btootm {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 999;

    .pickerBtn {
        margin: 0 5px;
        display: inline-block;
    }
}

button {
    position: fixed;
    right: 10px;
    top: 50px;
    z-index: 9;
    border: none;
    padding: 5px 10px;
    border-radius: 3px;
    outline: none;
}

.shade {
    position: fixed;
    top: 31px;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 9999;

    > div {
        flex: 1;

        > p {
            margin: 0;
            padding-bottom: 10px;
            text-align: center;
            color: #151617;
        }
        > div {
            width: 100%;
            height: 250px;
            background: rgba(255, 255, 255, 0.8);
        }
    }
}
</style>
<style>
.picker-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
</style>